module.exports = __webpack_public_path__ + "media/partners/pb95-538fc754.svg";